/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

import './layout.scss';
import { Footer, Header } from '@lanl-web/lanl-components';
import { LocalNav } from '../components';

// export const alert = 'Research Library Closed to Public. In order to maintain social distancing in response to COVID-19, the J. Robert Oppenheimer Study Center will be closed to the public starting on March 16th, 2020 until further notice. LANL badge holders will need to badge into the building.';
export const alert = '';

const Layout = ({ children, className, location }) => {
  const {
    directus: { rl_page_map },
  } = useStaticQuery(graphql`
    query {
      directus {
        rl_page_map(sort: "sort") {
          name
          slug
          sort
          parent {
            name
            slug
          }
          page(sort: "sort") {
            slug
            title
            sort
            parent {
              name
              slug
            }
          }
          template {
            name
          }
        }
      }
    }
  `);

  return (
    <>
      <Header />
      <Helmet>
        <script
          type='text/javascript'
          src='https://siteimproveanalytics.com/js/siteanalyze_6024875.js'
          async
        ></script>
      </Helmet>
      <LocalNav pageMap={rl_page_map} location={location} />
      <main className={className}>{children}</main>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Layout;
